import { Button } from "@chakra-ui/react";
import { useGetSettingsQuery } from "../../redux/services/settingsApi";

function StoreButton() {
  const { data: settings } = useGetSettingsQuery(undefined);
  const path = settings?.website;
  return path ? (
    <Button
      px={8}
      minW={"150px"}
      pb={{ md: "6" }}
      pt={{ md: "7" }}
      onClick={() => window.open(path)}
      color="white"
      bg="brand.700"
      _hover={{ bg: "brand.800" }}
    >
      متجر التبرعات
    </Button>
  ) : null;
}

export default StoreButton;
